import { Link } from "react-router-dom";
import { Reveal, ImageReveal } from "../components/Reveal";
import Seo from "../components/Seo";
import { IMAGES } from "../lib/site";

export default function About() {
    return (
        <div data-testid="page-about" className="pt-32">
            <Seo
                title="About — The House of United Bleachers"
                description="Vyom is the linen house of United Bleachers — a 75-year textile group in Coimbatore, India. Bed linen manufacturer, blanket maker, bath towel weaver and hospitality textile partner for distinguished brands across the world."
                path="/about"
            />
            <section className="container-vyom pb-16 md:pb-24">
                <Reveal>
                    <div className="text-[17.5px] uppercase tracking-overline text-vyom-mute mb-8">
                        About — Vyom
                    </div>
                </Reveal>
                <Reveal delay={0.05}>
                    <h1 className="font-serif-display text-5xl md:text-7xl lg:text-[104px] leading-[0.98] tracking-tight max-w-5xl">
                        A quieter standard,{" "}
                        <span className="italic">held</span> for
                        seventy-five years.
                    </h1>
                </Reveal>
                <Reveal delay={0.15}>
                    <p className="mt-10 max-w-xl text-[20px] leading-[1.8] text-vyom-mute">
                        Vyom is the linen house of United Bleachers — a
                        textile group founded in India in 1949. We craft bed
                        and bath linen for distinguished brands across the
                        world.
                    </p>
                </Reveal>
            </section>

            <section className="border-y border-vyom-rule">
                <div className="container-vyom py-0">
                    <ImageReveal
                        src={IMAGES.heritage}
                        alt="Spools of thread — heritage of United Bleachers"
                        className="aspect-[16/9] md:aspect-[21/9]"
                    />
                </div>
            </section>

            <section className="container-vyom section-pad">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
                    <div className="md:col-span-4">
                        <Reveal>
                            <div className="text-[17.5px] uppercase tracking-overline text-vyom-mute mb-6">
                                The lineage
                            </div>
                            <h2 className="font-serif-display text-3xl md:text-4xl leading-tight">
                                A house, not a factory.
                            </h2>
                        </Reveal>
                    </div>
                    <div className="md:col-span-7 md:col-start-6 space-y-8">
                        <Reveal delay={0.1}>
                            <p className="text-[20.5px] leading-[1.8] text-vyom-ink/90">
                                We do not chase scale; we hold standards. Our
                                looms are tuned by hand, our finishes
                                considered, our partners few. The result is
                                linen that arrives heavier in feel and lighter
                                in spirit — the kind a brand can build a
                                lifetime around.
                            </p>
                        </Reveal>
                        <Reveal delay={0.18}>
                            <p className="text-[19.5px] leading-[1.85] text-vyom-mute">
                                Founded as United Bleachers in 1949, our group
                                has spent three generations at the loom and
                                the finishing line. Vyom carries that legacy
                                forward — refined for the houses of today,
                                without losing the patience of yesterday.
                            </p>
                        </Reveal>
                    </div>
                </div>
            </section>

            <section className="border-t border-vyom-rule">
                <div className="container-vyom section-pad grid grid-cols-1 md:grid-cols-3 gap-10">
                    {[
                        {
                            n: "75+",
                            l: "Years of textile craft",
                        },
                        {
                            n: "100%",
                            l: "Long-staple cotton, always",
                        },
                        {
                            n: "∞",
                            l: "Trusted across the world",
                        },
                    ].map((s, i) => (
                        <Reveal key={s.n} delay={i * 0.08}>
                            <div data-testid={`stat-${i}`} className="border-t border-vyom-ink pt-8">
                                <div className="font-serif-display text-6xl md:text-7xl lg:text-8xl leading-none tracking-tight">
                                    {s.n}
                                </div>
                                <div className="mt-6 text-[19px] uppercase tracking-overline text-vyom-mute max-w-[14rem]">
                                    {s.l}
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </section>

            <section className="border-t border-vyom-rule">
                <div className="container-vyom section-pad text-center">
                    <Reveal>
                        <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight max-w-3xl mx-auto">
                            Build with a house that holds the loom — and the
                            line.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <div className="mt-10 inline-flex">
                            <Link
                                to="/contact"
                                data-testid="about-cta-contact"
                                className="text-[19px] whitespace-nowrap uppercase tracking-overline border border-vyom-ink px-8 py-3.5 text-vyom-ink hover:bg-vyom-ink hover:text-vyom-bg transition-colors duration-500"
                            >
                                Begin a conversation
                            </Link>
                        </div>
                    </Reveal>
                </div>
            </section>
        </div>
    );
}
